import { MosaicCard } from '../tornado/mosaic/mosaicCard.component';
import { MOSAIC_CARD_SIZE } from '../tornado/mosaic/mosaicCard.style';

export const ITEM_CONFIG = {
  services: {
    item: MosaicCard,
    sizes: MOSAIC_CARD_SIZE,
  },
  lives: {
    item: MosaicCard,
    sizes: MOSAIC_CARD_SIZE,
  },
  folders: {
    item: MosaicCard,
    sizes: MOSAIC_CARD_SIZE,
  },
};
